import { createFileRoute } from '@tanstack/react-router';
import { getHomeCopy } from '@/components/home/home-copy';
import { HomePage } from '@/components/home/home-page';
import { isCurrentLocaleIndexablePath } from '@/lib/locale';
import { seo } from '@/lib/seo';

export const Route = createFileRoute('/')({
  head: () => {
    const copy = getHomeCopy();
    const metadata = seo('/', {
      title: copy.seoTitle,
      description: copy.seoDescription,
      keywords: copy.keywords.join(', '),
    });
    // Untranslated locale homepages keep the `noindex` from `seo()`; adding a
    // second robots tag here would override it.
    if (!isCurrentLocaleIndexablePath('/')) return metadata;
    return {
      ...metadata,
      meta: [
        ...metadata.meta,
        { name: 'robots', content: 'index, follow, max-image-preview:large' },
      ],
    };
  },
  component: HomePage,
});
